"use client";

import { useEffect } from "react";

export default function ErrorBoundary({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    const msg = error?.message || "";
    // If caused by deployment mismatch (stale build chunks, old Server Actions, or RSC text/plain invariant),
    // automatically perform a fresh page reload to get the latest deployment.
    if (
      msg.includes("Expected RSC response") ||
      msg.includes("Failed to find Server Action") ||
      msg.includes("Loading chunk") ||
      msg.includes("ChunkLoadError")
    ) {
      console.warn("Deployment update detected. Refreshing to latest version...", msg);
      window.location.reload();
      return;
    }
    console.error("Unhandled client error:", error);
  }, [error]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center p-6 text-center">
      <div className="w-16 h-16 rounded-2xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center mb-4 text-amber-400 text-2xl font-bold">
        ⚠️
      </div>
      <h2 className="text-xl font-bold text-white mb-2">Notice: Update in Progress</h2>
      <p className="text-sm text-slate-400 max-w-md mb-6">
        The website has recently been updated with new features. Please reload the page to continue.
      </p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="px-6 py-2.5 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-slate-950 font-bold rounded-xl text-sm transition-all shadow-lg shadow-amber-500/20 cursor-pointer"
      >
        Reload Page
      </button>
    </div>
  );
}
